<a>
  <span ng-bind-html="match.model.credentNumber | uibTypeaheadHighlight:query"></span>
  <span ng-bind-html="match.model.credentName | uibTypeaheadHighlight:query"></span>
  <span class="second-column">{{match.model.personName}}</span>
</a>
